import { h } from 'vue'
import NavListItem from './NavListItem.vue'
import DropDownAssetHeader from './DropDownAssetHeader.vue'
import DropDownUserHeader from './DropDownUserHeader.vue'
import DropDownDownloadHeader from './DropDownDownloadHeader.vue'
import { locales } from '@/utils/locale'

import { useI18n, useLocalePath, useSwitchLocalePath } from '#imports'

// 合约下拉列表icon
import iconPerpetual from '@/assets/images/header/icon-perpetual.svg'
import iconFee from '@/assets/images/header/icon-fee.svg'
import iconFund from '@/assets/images/header/icon-fund.svg'

// 订单下拉列表icon
import iconSpot from '@/assets/images/header/icon-spot.svg'
import iconFutures from '@/assets/images/header/icon-futures.svg'
import iconOrder from '@/assets/images/header/icon-order.svg'
import iconChecked from '@/assets/images/header/icon-checked.svg'
import apiManagement from '@/assets/images/header/icon-newAPI.svg'

// 资产下拉列表icon
// import iconTotalAsset from '@/assets/images/header/icon-total-asset.svg'
// import iconFuturesAsset from '@/assets/images/header/icon-futures-asset.svg'
// import iconSpotAsset from '@/assets/images/header/icon-spot-asset.svg'
// import iconDeposit from '@/assets/images/header/icon-deposit.svg'
// import iconWithdraw from '@/assets/images/header/icon-withdraw.svg'
// import iconTransfer from '@/assets/images/header/icon-transfer.svg'

// 用户下拉列表icon
import iconAccount from '@/assets/images/header/icon-account.svg'
import iconInvite from '@/assets/images/header/icon-invite.svg'
import iconCard from '@/assets/images/header/icon-card.svg'
import iconLogout from '@/assets/images/header/icon-logout.svg'

import { spotOrigin } from '~/utils'
import { useUserStore } from '~/store/user'

export function useFutureDropOptions() {
  const { t } = useI18n()
  const localePath = useLocalePath()

  const list = computed(() => [
    { key: 'perpetual', label: t('nav.perpetual'), name: 'futures-symbol', icon: iconPerpetual, href: localePath('/futures') },
    { key: 'fee', label: t('nav.fee'), icon: iconFee, name: 'futures-fee', href: localePath('/futures/funding-rate') },
    { key: 'fund', label: t('nav.fund'), icon: iconFund, name: 'futures-fund', href: localePath('/futures/fund') },
  ])
  return computed(() => list.value.map(i => ({
    type: 'render',
    render: () => h(NavListItem, i),
  })))
}

export function useOrderDropOptions() {
  const { t } = useI18n()

  const list = [
    { key: 'spot', icon: iconSpot, label: t('nav.spotOrder'), href: `${spotOrigin}/#/order/spot` },
    { key: 'futures', icon: iconFutures, label: t('nav.futuresOrder'), href: `${spotOrigin}/#/order/futures` },
  ]
  return list.map(i => ({
    type: 'render',
    render: () => h(NavListItem, { href: i.href, icon: i.icon, label: i.label }),
  }))
}

export function useAssetDropOptions() {
  const { t } = useI18n()
  const localePath = useLocalePath()
  const headerList = [
    { key: 'total', label: `${t('总资产折合')}`, href: `#` },
    // { key: 'future', icon: iconFuturesAsset, label: `${t('nav.futuresAsset')}(USDT)`, href: `${spotOrigin}/#/assets/home?tabId=future` },
    // { key: 'spot', icon: iconSpotAsset, label: `${t('nav.spotAsset')}(USDT)`, href: `${spotOrigin}/#/assets/home?tabId=spot` },
  ]
  const list = [
    { key: 'spotAsset', icon: iconSpot, label: t('现货账户'), href: localePath('/my/wallet/spot') },
    { key: 'spotOrder', icon: iconOrder, label: t('订单中心'), href: localePath('/my/orders/spot') },
    // { key: 'transfer', icon: iconTransfer, label: t('nav.transfer'), href: `${spotOrigin}/#/assets/home?showTransfer=true` },
  ]
  return [{ key: 'header', type: 'render', render: () => h(DropDownAssetHeader, { list: headerList }) }]
    .concat(list.map(i => ({
      type: 'render',
      render: () => h(NavListItem, { href: i.href, icon: i.icon, label: i.label }),
    })))
}

export function useUserDropOptions() {
  const { t } = useI18n()
  const user = useUserStore()
  const openApiWhite = user.info.openApiWhite
  const localePath = useLocalePath()
  const router = useRouter()
  const list = [
    { key: 'account', icon: iconAccount, label: t('账户与安全'), href: localePath('/user') },
    // { key: 'fee', icon: iconFee, label: t('身份认证'), href: localePath('/user') },
    { key: 'invite', icon: iconInvite, label: t('邀请好友'), href: localePath('/referral') },
    { key: 'card', icon: iconCard, label: t('卡券中心'), href: `` },
    ...(openApiWhite ? [{ key: 'api', icon: apiManagement, label: t('API管理'), href: localePath('/api-management') }] : []),
    { key: 'logout', icon: iconLogout, label: t('退出登录'), action: () => {
      user.logout()
      router.replace({
        path: localePath('/'),
      })
      return true
    } },
  ]
  return [{ key: 'header', type: 'render', render: () => h(DropDownUserHeader) }]
    .concat(list.map(i => ({
      type: 'render',
      render: () => h(NavListItem, i),
    })))
}

export function useDownloadDropOptions() {
  return [{ key: 'header', type: 'render', render: () => h(DropDownDownloadHeader) }]
}

export function useLanguageDropOptions() {
  const { locale } = useI18n()
  return locales.map(i => ({
    key: i.code,
    type: 'render',
    render: () => {
      const switchLocalePath = useSwitchLocalePath()
      const path = switchLocalePath(i.code) || `/${i.code}` // 兼容 error page
      return h('div', { className: 'min-w-[180px]' }, [h(NavListItem, {
        href: path,
        label: i.title,
        itemClass: '!h-[32px]',
        selectedIcon: locale.value === i.code ? iconChecked : false,
      })])
    },
  }))
}
